package com.anjuros.website.templates.template5.modules


import com.anjuros.website.templates.template5.util.ResKey


enum class Template5Product(
    val category: Template5Category,
    val image: String,
    val title: ResKey,
    val description: ResKey,
    val price: String
) {

    //====================================================
    // CATEGORY 1
    //====================================================

    CATEGORY1_PRODUCT1(
        category = Template5Category.CATEGORY1,
        image = "template5_category1_product1.jpg",
        title = ResKey.TEMPLATE5_CATEGORY1_PRODUCT1_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY1_PRODUCT1_TEXT,
        price = "£45"
    ),

    CATEGORY1_PRODUCT2(
        category = Template5Category.CATEGORY1,
        image = "template5_category1_product2.jpg",
        title = ResKey.TEMPLATE5_CATEGORY1_PRODUCT2_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY1_PRODUCT2_TEXT,
        price = "£55"
    ),

    CATEGORY1_PRODUCT3(
        category = Template5Category.CATEGORY1,
        image = "template5_category1_product3.jpg",
        title = ResKey.TEMPLATE5_CATEGORY1_PRODUCT3_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY1_PRODUCT3_TEXT,
        price = "£60"
    ),
    CATEGORY1_PRODUCT4(
        category = Template5Category.CATEGORY1,
        image = "template5_category1_product4.jpg",
        title = ResKey.TEMPLATE5_CATEGORY1_PRODUCT4_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY1_PRODUCT4_TEXT,
        price = "£50"
    ),
    CATEGORY1_PRODUCT5(
        category = Template5Category.CATEGORY1,
        image = "template5_category1_product5.jpg",
        title = ResKey.TEMPLATE5_CATEGORY1_PRODUCT5_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY1_PRODUCT5_TEXT,
        price = "£65"
    ),
    CATEGORY1_PRODUCT6(
        category = Template5Category.CATEGORY1,
        image = "template5_category1_product6.jpg",
        title = ResKey.TEMPLATE5_CATEGORY1_PRODUCT6_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY1_PRODUCT6_TEXT,
        price = "£40"
    ),

    //====================================================
    // CATEGORY 2
    //====================================================

    CATEGORY2_PRODUCT1(
        category = Template5Category.CATEGORY2,
        image = "template5_category2_product1.jpg",
        title = ResKey.TEMPLATE5_CATEGORY2_PRODUCT1_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY2_PRODUCT1_TEXT,
        price = "£180"
    ),

    CATEGORY2_PRODUCT2(
        category = Template5Category.CATEGORY2,
        image = "template5_category2_product2.jpg",
        title = ResKey.TEMPLATE5_CATEGORY2_PRODUCT2_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY2_PRODUCT2_TEXT,
        price = "£220"
    ),

    CATEGORY2_PRODUCT3(
        category = Template5Category.CATEGORY2,
        image = "template5_category2_product3.jpg",
        title = ResKey.TEMPLATE5_CATEGORY2_PRODUCT3_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY2_PRODUCT3_TEXT,
        price = "£250"
    ),
    CATEGORY2_PRODUCT4(
        category = Template5Category.CATEGORY2,
        image = "template5_category2_product4.jpg",
        title = ResKey.TEMPLATE5_CATEGORY2_PRODUCT4_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY2_PRODUCT4_TEXT,
        price = "£350"
    ),
    CATEGORY2_PRODUCT5(
        category = Template5Category.CATEGORY2,
        image = "template5_category2_product5.jpg",
        title = ResKey.TEMPLATE5_CATEGORY2_PRODUCT5_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY2_PRODUCT5_TEXT,
        price = "£150"
    ),

    //====================================================
    // CATEGORY 3
    //====================================================

    CATEGORY3_PRODUCT1(
        category = Template5Category.CATEGORY3,
        image = "template5_category3_product1.jpg",
        title = ResKey.TEMPLATE5_CATEGORY3_PRODUCT1_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY3_PRODUCT1_TEXT,
        price = "£18"
    ),

    CATEGORY3_PRODUCT2(
        category = Template5Category.CATEGORY3,
        image = "template5_category3_product2.jpg",
        title = ResKey.TEMPLATE5_CATEGORY3_PRODUCT2_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY3_PRODUCT2_TEXT,
        price = "£20"
    ),

    CATEGORY3_PRODUCT3(
        category = Template5Category.CATEGORY3,
        image = "template5_category3_product3.jpg",
        title = ResKey.TEMPLATE5_CATEGORY3_PRODUCT3_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY3_PRODUCT3_TEXT,
        price = "£22"
    ),
    CATEGORY3_PRODUCT4(
        category = Template5Category.CATEGORY3,
        image = "template5_category3_product4.jpg",
        title = ResKey.TEMPLATE5_CATEGORY3_PRODUCT4_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY3_PRODUCT4_TEXT,
        price = "£25"
    ),

    //====================================================
    // CATEGORY 4
    //====================================================

    CATEGORY4_PRODUCT1(
        category = Template5Category.CATEGORY4,
        image = "template5_category4_product1.jpg",
        title = ResKey.TEMPLATE5_CATEGORY4_PRODUCT1_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY4_PRODUCT1_TEXT,
        price = "£12"
    ),

    CATEGORY4_PRODUCT2(
        category = Template5Category.CATEGORY4,
        image = "template5_category4_product2.jpg",
        title = ResKey.TEMPLATE5_CATEGORY4_PRODUCT2_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY4_PRODUCT2_TEXT,
        price = "£16"
    ),

    CATEGORY4_PRODUCT3(
        category = Template5Category.CATEGORY4,
        image = "template5_category4_product3.jpg",
        title = ResKey.TEMPLATE5_CATEGORY4_PRODUCT3_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY4_PRODUCT3_TEXT,
        price = "£20"
    ),
    CATEGORY4_PRODUCT4(
        category = Template5Category.CATEGORY4,
        image = "template5_category4_product4.jpg",
        title = ResKey.TEMPLATE5_CATEGORY4_PRODUCT4_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY4_PRODUCT4_TEXT,
        price = "£15"
    ),

    //====================================================
    // CATEGORY 5
    //====================================================

    CATEGORY5_PRODUCT1(
        category = Template5Category.CATEGORY5,
        image = "template5_category5_product1.jpg",
        title = ResKey.TEMPLATE5_CATEGORY5_PRODUCT1_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY5_PRODUCT1_TEXT,
        price = "£24"
    ),

    CATEGORY5_PRODUCT2(
        category = Template5Category.CATEGORY5,
        image = "template5_category5_product2.jpg",
        title = ResKey.TEMPLATE5_CATEGORY5_PRODUCT2_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY5_PRODUCT2_TEXT,
        price = "£26"
    ),

    CATEGORY5_PRODUCT3(
        category = Template5Category.CATEGORY5,
        image = "template5_category5_product3.jpg",
        title = ResKey.TEMPLATE5_CATEGORY5_PRODUCT3_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY5_PRODUCT3_TEXT,
        price = "£28"
    ),

    CATEGORY5_PRODUCT4(
        category = Template5Category.CATEGORY5,
        image = "template5_category5_product4.jpg",
        title = ResKey.TEMPLATE5_CATEGORY5_PRODUCT4_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY5_PRODUCT4_TEXT,
        price = "£30"
    ),

    CATEGORY5_PRODUCT5(
        category = Template5Category.CATEGORY5,
        image = "template5_category5_product5.jpg",
        title = ResKey.TEMPLATE5_CATEGORY5_PRODUCT5_TITLE,
        description = ResKey.TEMPLATE5_CATEGORY5_PRODUCT5_TEXT,
        price = "£20"
    );

}

enum class Template5Category(
    val title: ResKey,
) {

    CATEGORY1(
        title = ResKey.TEMPLATE5_CATEGORY1,
    ),

    CATEGORY2(
        title = ResKey.TEMPLATE5_CATEGORY2,
    ),

    CATEGORY3(
        title = ResKey.TEMPLATE5_CATEGORY3,
    ),

    CATEGORY4(
        title = ResKey.TEMPLATE5_CATEGORY4,
    ),

    CATEGORY5(
        title = ResKey.TEMPLATE5_CATEGORY5,
    )

}